import "./YormLoader.css";

const SPARKLES = [
  { src: "/loader/yorm-s1.webp", origin: "70% 56%", delay: "0s" },
  { src: "/loader/yorm-s2.webp", origin: "63.6% 83%", delay: "0.5s" },
  { src: "/loader/yorm-s3.webp", origin: "82.4% 69%", delay: "1s" },
];

export const YormLoader = ({ inline = false, thinking = false }) => {
  const logo = (
    <div className={`yorm-loader-logo${inline ? " yorm-loader-logo--inline" : ""}${thinking ? " yorm-loader-logo--thinking" : ""}`}>
      <img src="/loader/yorm-y.webp" alt="" className="yorm-loader-layer yorm-loader-y" />
      {SPARKLES.map((s) => (
        <img
          key={s.src}
          src={s.src}
          alt=""
          className="yorm-loader-layer yorm-loader-sparkle"
          style={{ transformOrigin: s.origin, animationDelay: s.delay }}
        />
      ))}
    </div>
  );
  if (thinking) return logo;
  if (inline) {
    return <div data-testid="yorm-inline-loader" role="status" aria-label="Loading">{logo}</div>;
  }
  return (
    <div className="yorm-loader-screen" data-testid="yorm-page-loader" role="status" aria-label="Loading">
      {logo}
    </div>
  );
};

export default YormLoader;
